module.exports = __webpack_public_path__ + "img/p2.8a7aeb15.png";